import { useState } from 'react';

/**
 * Swipe detection hook for mobile navigation.
 * Returns { onTouchStart, onTouchMove, onTouchEnd } to attach to a container.
 */
export function useSwipeNavigation(onSwipeUp, onSwipeDown) {
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [isSwipe, setIsSwipe] = useState(false);

  const minSwipeDistance = 80;

  const onTouchStart = (e) => {
    const target = e.target;
    const isInteractive = target.closest('button, a, input, select, textarea, [role="button"]');
    if (!isInteractive) {
      setTouchEnd(null);
      setTouchStart(e.targetTouches[0].clientY);
      setIsSwipe(false);
    }
  };

  const onTouchMove = (e) => {
    if (touchStart !== null) {
      const currentY = e.targetTouches[0].clientY;
      const distance = Math.abs(touchStart - currentY);
      if (distance > 20) {
        setIsSwipe(true);
        setTouchEnd(currentY);
      }
    }
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd || !isSwipe) {
      setTouchStart(null);
      setTouchEnd(null);
      setIsSwipe(false);
      return;
    }
    const distance = touchStart - touchEnd;
    const isUpSwipe = distance > minSwipeDistance;
    const isDownSwipe = distance < -minSwipeDistance;
    if (isUpSwipe && onSwipeUp) onSwipeUp();
    if (isDownSwipe && onSwipeDown) onSwipeDown();
    setTouchStart(null);
    setTouchEnd(null);
    setIsSwipe(false);
  };

  return { onTouchStart, onTouchMove, onTouchEnd };
}
